export const pageContextInitIsPassedToClient = '_pageContextInitIsPassedToClient';
